import React from 'react';
import { default as PlansComponent } from '@fff-web/fff-ui-shared/Plans';
import {
  useReactivateMyMembershipContext,
  IReactivateMembershipContext,
} from '../../../utils/ContextProviders/ReactivateContext';
import useGetPricesByPlan from '../../../utils/hooks/useGetPricesByPlan';
import { IPlanCode } from '../../../utils/Interfaces';
import { GROWTH_MY_REACTIVATE_MEMBERSHIP } from '../../../utils/Optimizely/featureFlagVariations';
import styles from './MembershipPlans.module.scss';
import classNames from 'classnames';

export interface IMembershipPlansProps {
  planSectionRef: React.RefObject<HTMLDivElement>;
  reactivateCaptchaRef: React.MutableRefObject<any>;
}

const MembershipPlans: React.FC<IMembershipPlansProps> = ({
  planSectionRef,
  reactivateCaptchaRef,
}) => {
  const { growthMyMembership, setPlanCode, selectedPlanCode } =
    useReactivateMyMembershipContext();
  const { variables, variationKey } =
    growthMyMembership as IReactivateMembershipContext;

  const { isLoadingPrices, seasonalPrice, annualPrice } =
    useGetPricesByPlan(growthMyMembership);

  const seasonalPerkList = variables.seasonalPerks?.list;
  const annualPerkList = variables.annualPerks?.list;

  const annualPlanSubtitle = variables?.annualCardSubtitle;

  const annualData = {
    title: 'Annual',
    subtitle: annualPlanSubtitle,
    price: annualPrice?.price,
    isLoadingPrice: isLoadingPrices,
    annualPrice: annualPrice?.annualPrice,
    isSelected: selectedPlanCode === IPlanCode.ANNUAL,
    onSelectPlan: () => onSelectPlanCode(IPlanCode.ANNUAL),
  };

  const seasonalData = {
    title: 'Seasonal',
    subtitle: 'Pay per box',
    price: seasonalPrice?.price,
    isLoadingPrice: isLoadingPrices,
    disclaimer: 'Billed quarterly.',
    isSelected: selectedPlanCode === IPlanCode.SEASONAL,
    onSelectPlan: () => onSelectPlanCode(IPlanCode.SEASONAL),
  };

  const onSelectPlanCode = (planCode: IPlanCode) => {
    setPlanCode(planCode);
    const captcha = reactivateCaptchaRef.current;
    if (captcha) {
      captcha.execute();
    }
  };

  const plansComponentStyles = classNames({
    [styles.customPlanStyles]:
      variationKey === GROWTH_MY_REACTIVATE_MEMBERSHIP.VARIATION_E,
  });

  return (
    <section ref={planSectionRef} className={styles.planSectionWrapper}>
      <div className={styles.planSectionTitle}>
        <h2>{variables.planSectionTitle}</h2>
        <h5>{variables.planSectionSubtitle}</h5>
      </div>
      <PlansComponent
        componentStyles={plansComponentStyles}
        annualData={{
          ...annualData,
          perksList: annualPerkList,
        }}
        seasonalData={{
          ...seasonalData,
          perksList: seasonalPerkList,
        }}
      />
    </section>
  );
};

export default MembershipPlans;
